import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {  vendorApi } from "../api/api";
import YourProjectDocuments from "../components/YourProperty/YourProjectDocuments.js";
import { useSelector } from "react-redux";
import YourProjectPlan from "../components/YourProperty/YourProjectPlot";
import ProjectDocument from "../components/ProjectDetails/ProjectDocument";
import YourPropertyImgs from "../components/YourProperty/YourPropertyImgs.js";
import PropertyImages from "../components/PropertyDetalis/PropertyImages.js";
import ProjectImages from "../components/ProjectDetails/ProjectImages.js";
import YourProjectImages from "../components/YourProperty/YourProjectImages.js";
import YourProjectLayout from "../components/YourProperty/YourProjectLayout.js";
import Loader from "../components/common/Loader.js";


const YourProjectScreen = () => {
  const userId=useSelector((state)=>state.user.userId);

  const location = useLocation();
  const {property}=location.state;
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
   const theme = useSelector((data) => data.themeValue.colors);

  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const runEffect = async () => {
      
      try {
        const response = await vendorApi.getProjectById(property.id);
        if (response.status === 200) {
          setProjectData(response.data);
          
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };
  
    runEffect();
  }, [property.id]);
  
  

  const layoutConfig = [
    {
      id: "ProjectLayoutPage",
      render: () => <YourProjectLayout data={projectData}/>,
    },
    {
      id:"ProjectPlotStructure",  
      render:() => <YourProjectPlan data={projectData}/>,
    },
     {
      id:"ProjectImages",
      render:() => <YourProjectImages data={projectData}/>
    },
    {
      id:"ProjectDocuments",
      render:() => <YourProjectDocuments data={projectData}/>
    }

  ];

  // if (!isAuthenticated) {
  //   return (
  //     <div style={styles.container}>
  //       <h2 style={styles.heading}>Login to View Property Details</h2>
  //       <p style={styles.loginMessage}>Please log in to access the property details.</p>
  //       <button onClick={() => navigate('/login',{state:{from : location}})} style={styles.loginButton}>Login</button>
  //     </div>
  //   );
  // }

  return (
    <div style={styles.container}>
      {/* <h2 style={styles.heading}>Project Details</h2> */}

      {loading ? (
        <Loader/>
      ) : (
        <div style={styles.sectionWrapper}>
          {layoutConfig.map((section) => (
            <div key={section.id} style={styles.section}>
              {section.render()}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
     maxWidth: "100%",
    margin: "0 auto",
    padding: "10px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    // backgroundColor:"blue"
  },
  heading: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "24px",
    color: "#333",
  },
  loadingText: {
    fontSize: "16px",
    color: "#555",
    textAlign: "center",
    marginTop: "40px",
  },
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  // section: {
  //   padding: "20px",
  //   borderRadius: "12px",
  //   backgroundColor: theme.background,
  //   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  // },
};

export default YourProjectScreen;